// extracted by mini-css-extract-plugin
export default {"wrapper":"rodo_wrapper__mdlGC","button":"rodo_button__S+w-U"};